
<template>
    <BaseComponent name="catalog_teaser" v-if="catalog && catalog.is_description">
        <div class="teaser mb-3" :class="{'expanded':expanded}">
            <div class="content content_styles catalog-card mb-2">
                <div class="row">
                    <div v-if="catalog.image && catalog.image.html" v-html="catalog.image.html" class="col-auto d-none d-md-block"></div>
                    <div class="col" v-html="catalog.teaser_description"/>
                </div>
                <div>
                    <span class="fade-block product-item-name-fade"></span>
                </div>
            </div>
            <div class="text-end" v-if="catalog.teaser_description.length > 300">
                <button class="view-more text-uppercase text-decoration-none btn btn-link" @click="emit('description-expanded')" :aria-expanded="expanded" :class="{'collapsed' : !expanded}">
                    <span class="expanded">{{ $t('catalog.view_less') }}</span>
                    <span class="collapsed">{{ $t('catalog.view_more') }}</span>
                </button>
            </div>
        </div>
    </BaseComponent>
</template>

<script setup>
defineProps({
    catalog: Object,
    expanded: Boolean,
});
const emit = defineEmits(['description-expanded'])
</script>
